app.factory("AuthService", ['$http', '$state', '$q',
    function ($http, $state, $q) {
        var AuthService = {
            checkedRestore: false,
            authenticated: false,
            secondStep: false,
            user: null,
            profiles: null,
            phone: null,
            userId: null,
            isRoot: false,
            changeMailLater: false,
            needTwoFactor: false
        };

        AuthService.getProfiles = function () {
            if (AuthService.user === null) {
                return AuthService.restore().then(function () {
                    return AuthService.user.profiles;
                });
            }

            return $q.resolve(AuthService.user.profiles);
        };

        AuthService.login = function (email, password) {
            return $http.post("/auth/login", { email: email, password: password }).then(function (resp) {
                if (resp.data.code === 'need_verify') {
                    AuthService.needSmsAuth = false;
                    AuthService.needTwoFactor = false;
                    AuthService.secondStep = true;
                    AuthService.phone = resp.data.phone;
                    AuthService.userId = resp.data.userId;
                    localStorage.setItem('userId', resp.data.userId);
                    localStorage.setItem('phone', resp.data.phone);
                    return $q.resolve();
                } else if (resp.data.needSmsAuth) {
                    AuthService.needSmsAuth = true;
                    return $q.resolve();
                } else if (resp.data.needTwoFactor) {
                    AuthService.needTwoFactor = true;
                    return $q.resolve();
                }
                AuthService.needSmsAuth = false;
                AuthService.secondStep = false;
                AuthService.authenticated = true;
                AuthService.user = resp.data;
                if (AuthService.user.employee)
                    AuthService.isRoot = AuthService.user.employee.isRoot
                return AuthService.user;
            }, function (res) {
                return $q.reject(res.status);
            });
        };

        AuthService.pickStudentProfile = function (user) {
            return user.profiles.filter(function (p) {
                if (p.type === 'student' && p.state === 'active') {
                    return p;
                }
            })[0] || user.profiles.filter(function (p) {
                return p.type === 'student' && p.state === 'pause';
            })[0] || user.profiles.filter(function (p) {
                return p.type === 'student';
            })[0];
        }

        AuthService.logout = function () {
            return $http.post("/auth/logout").then(function () {
                AuthService.authenticated = false;
                return true;
            });
        };


        AuthService.changeSessionObject = function (userId, profile) {
            return $http.post("/auth/changeSession", { userId: userId, profile: profile }).then(function () {
                return true;
            });
        };

        AuthService.chooseEmployeeProfile = function (profile) {
            return $http.post("/auth/choose/employee/profile", { profile: profile }).then(function () {
                return true;
            });
        };


        AuthService.getUserData = function () {
            if (AuthService.user !== null) {
                return $q.resolve(AuthService.user);
            } else {
                return AuthService.restore().then(function () {
                    return AuthService.user;
                });
            }
        };

        AuthService.restore = function () {
            return $http.get("/auth/passport").then(function (resp) {
                AuthService.authenticated = true;
                AuthService.user = resp.data;
                AuthService.checkedRestore = true;
                if (AuthService.user.employee)
                    AuthService.isRoot = AuthService.user.employee.isRoot
                return resp.status;
            }, function (resp) {
                AuthService.checkedRestore = true;
                return resp.status;
            });
        };

        AuthService.getPass = function () {
            return $http.get("/auth/passport").then(function (resp) {
                AuthService.user = resp.data;
                if (AuthService.user.employee)
                    AuthService.isRoot = AuthService.user.employee.isRoot
                return resp;
            }, function (resp) {
                return resp;
            });
        };

        AuthService.emis = function (emisId) {
            return $http.get("/auth/emis/" + emisId).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.restoreUser = function (params) {
            return $http.post("/auth/restore", {
                email: params.email,
                personalNumber: params.personalNumber
            }).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.reset = function (params) {
            return $http.post("/auth/reset", {
                email: params.email
            }).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.resetPassword = function (params) {
            return $http.post("/auth/password/reset", {
                password: params.password,
                restore: params.restore
            }).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.changePassword = function (params) {
            return $http.post("/auth/password/change", {
                password: params.password,
                oldPassword: params.oldPassword
            }).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.changeEmail = function (params) {
            return $http.post("/auth/email/change", {
                email: params.email
            }).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.verifyEmail = function (params) {
            return $http.post("/auth/email/verify", {
                token: params.token
            }).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.updatePassword = function (params) {
            return $http.post("/auth/password/update", {
                user: params.user,
                password: params.password
            }).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.fb = function () {
            return $http.get("/auth/facebook").then(function (resp) {
                console.log(resp)
                return resp;
            })
        };

        AuthService.hasRight = function (right) {
            return AuthService.user && AuthService.user.rights.indexOf(right) !== -1;
        };

        AuthService.hasRole = function (role) {
            return AuthService.user && AuthService.user.roles.indexOf(role) !== -1;
        };

        AuthService.verifyPhone = function (params) {
            return $http.post("/auth/verify/phone", {
                userId: params.userId,
                phone: params.phone
            }).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.verifyCode = function (params) {
            return $http.post("/auth/verify/code", {
                userId: params.userId,
                code: params.code
            }).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.smsAuth = function (params) {
            return $http.post("/auth/sms/verify", {
                userId: params.userId,
                code: params.code
            }).then(function (resp) {
                if (resp.data._id) {
                    AuthService.authenticated = true;
                    AuthService.needSmsAuth = false;
                    AuthService.secondStep = false;
                    AuthService.authenticated = true;
                    AuthService.user = resp.data;
                    if (AuthService.user.employee)
                        AuthService.isRoot = AuthService.user.employee.isRoot
                    return AuthService.user;
                }

                return resp.data;
            });
        };

        AuthService.requestPhoneChange = function (params) {
            return $http.post("/auth/phone/change/request", {
                phone: params.phone
            }).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.confirmPhoneChange = function (params) {
            return $http.post("/auth/phone/change/update", {
                smsCode: params.smsCode
            }).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.getAlerts = function () {
            return $http.get("/auth/alerts", {}).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.alertAction = function (data) {
            return $http.post("/auth/alerts", data).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.checkPasswordChange = function () {
            return $http.get("/auth/checkPassChange", {}).then(function (resp) {
                return resp.data;
            });
        }

        AuthService.createTwoFactor = function () {
            return $http.post("/auth/two-factor/create", {}).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.checkTwoFactor = function (params) {
            return $http.post("/auth/two-factor/check", params).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.enableTwoFactor = function (params) {
            return $http.post("/auth/two-factor/enable", params).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.disableTwoFactor = function () {
            return $http.post("/auth/two-factor/disable", {}).then(function (resp) {
                return resp.data;
            });
        };

        AuthService.verifyTwoFactor = function (params) {
            return $http.post("/auth/two-factor/verify", params).then(function (resp) {
                if (resp.data._id) {
                    AuthService.authenticated = true;
                    AuthService.secondStep = false;
                    AuthService.needTwoFactor = false;
                    AuthService.user = resp.data;
                    if (AuthService.user.employee) {
                        AuthService.isRoot = AuthService.user.employee.isRoot;
                    }
                    return AuthService.user;
                }

                return resp.data;
            });
        };

        AuthService.enableEmailNotification = function () {
            return $http.post("/auth/email-notification/enable").then(function (resp) {
                return resp.data;
            });
        };

        AuthService.disableEmailNotification = function () {
            return $http.post("/auth/email-notification/disable").then(function (resp) {
                return resp.data;
            });
        };

        return AuthService;
    }
]);
